var hotelLocationPagesDE = {
  'de/flughafenhotel-berlin-schoenefeld': 'Berlin-Schönefeld',
  'de/flughafenhotel-berlin-tegel': 'Berlin-Tegel',
  'de/flughafenhotel-bremen': 'Bremen',
  'de/hotel-flughafen-dortmund': 'Dortmund',
  'de/flughafenhotel-duesseldorf': 'Düsseldorf',
  'de/flughafenhotel-dresden': 'Dresden',
  'de/flughafenhotel-frankfurt': 'Frankfurt am Main',
  'de/flughafenhotel-frankfurt-hahn': 'Frankfurt-Hahn',
  'de/flughafenhotel-friedrichshafen': 'Friedrichshafen',
  'de/flughafenhotel-hamburg': 'Hamburg',
  'de/flughafenhotel-hannover': 'Hannover',
  'de/flughafenhotel-koeln-bonn': 'Köln-Bonn',
  'de/flughafenhotel-leipzig': 'Leipzig/Halle',
  'de/flughafenhotel-muenchen': 'München',
  'de/flughafenhotel-nuernberg': 'Nürnberg',
  'de/flughafenhotel-stuttgart': 'Stuttgart',
  'de/hotelmitundohneparken2': 'Flughafen-Hotelsin Europa'
}

module.exports = hotelLocationPagesDE



// WEBPACK FOOTER //
// ./shared/config/hotelLocationPagesDE.js